import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface ReactionsFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for the reactions filter (thumbs up/down).
 */
export const ReactionsFilter = ({ filterIndex }: ReactionsFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();
  const { update } = useFieldArray({ control, name: 'filters' });

  const reactions = useWatch({ control, name: `filters.${filterIndex}.reactions` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;

    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null;
    }

    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, reactions: booleanValue });
  };

  const currentValue = reactions === true ? 'true' : reactions === false ? 'false' : '';

  return (
    <RadioGroup value={currentValue} onValueChange={handleChange} className="gap-0">
      <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
        <RadioGroupItem value="true" id={`reactions-true-${filterIndex}`} />
        <Label htmlFor={`reactions-true-${filterIndex}`} className="cursor-pointer font-normal">
          {t('analytics.reactions_thumbs_up')}
        </Label>
      </div>
      <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
        <RadioGroupItem value="false" id={`reactions-false-${filterIndex}`} />
        <Label htmlFor={`reactions-false-${filterIndex}`} className="cursor-pointer font-normal">
          {t('analytics.reactions_thumbs_down')}
        </Label>
      </div>
    </RadioGroup>
  );
};
